const LockIcon = ({ fill = "rgba(0,0,0,0.8)" }: { fill?: string }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="flex-shrink-0"
    >
      <g clipPath="url(#clip0_298_837)">
        <path
          d="M9.87793 22.2148H18.1133C19.4668 22.2148 20.1436 21.5381 20.1436 20.0615V13.8389C20.1436 12.5381 19.6162 11.8613 18.5527 11.7207V9.66406C18.5527 6.32422 16.3291 4.71582 13.9912 4.71582C11.6621 4.71582 9.43848 6.32422 9.43848 9.66406V11.7207C8.375 11.8613 7.84766 12.5381 7.84766 13.8389V20.0615C7.84766 21.5381 8.51562 22.2148 9.87793 22.2148ZM11.1084 9.49707C11.1084 7.43164 12.418 6.31543 13.9912 6.31543C15.5645 6.31543 16.8828 7.43164 16.8828 9.49707V11.6943H11.1084V9.49707ZM10.1328 20.6504C9.74609 20.6504 9.55273 20.4658 9.55273 20V13.9004C9.55273 13.4346 9.74609 13.2676 10.1328 13.2676H17.8672C18.2539 13.2676 18.4385 13.4346 18.4385 13.9004V20C18.4385 20.4658 18.2539 20.6504 17.8672 20.6504H10.1328Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_298_837">
          <rect width="28" height="28" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default LockIcon;
